import config from "devextreme/core/config";

config({
    licenseKey: "ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImQyNWM5NGVkLTM3ZjgtNDA3ZS1iY2Q0LWNjYTZiNjBmZTBjMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.hJRvyiOYvYKOB2St7stXXOJmb8M7nk6C8np8KepZW9fFKJXoiEbqEzXOLAqTgTHXEhqQkL+KLBOgIqrTpGGv/b49ZZFwCJf++sEZagsRvAMtDHbvNOPtdUJhQn8vRcJIbZec8g=="
});